import { useCallback } from 'react'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'
import { useHover } from '@react-aria/interactions'
import cx from 'classnames'
import Styles from '../ColorOption.module.scss'
import { ColorPicker } from '../ColorPicker/ColorPicker'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'

interface ColorItemProps {
  color: string
  index: number
  onColorChange: (index: number) => (color: string) => void
  onPersistChanges: () => void
  onDeleteClick: (index: number) => () => void
  isDeletable?: boolean
  previewColors?: string[]
  setPreviewColors?: (colors: string[]) => void
}

export const ColorItem = ({
  color,
  index,
  onColorChange,
  onPersistChanges,
  onDeleteClick,
  isDeletable = true,
  previewColors,
  setPreviewColors,
}: ColorItemProps) => {
  const { hoverProps, isHovered } = useHover({})
  const persistChanges = useCallback(() => {
    onPersistChanges()
  }, [onPersistChanges])

  return (
    <ColorPicker
      color={color}
      onChange={(color) => {
        if (color) {
          onColorChange(index)(color)
        }
      }}
      onClose={persistChanges}
      previewColors={previewColors}
      setPreviewColors={setPreviewColors}
    >
      <div className={Styles.colorItem} {...hoverProps}>
        <div className={cx(Styles.colorSwatchWrapper, Styles.editing)}>
          <div
            className={Styles.colorSwatch}
            style={{ backgroundColor: color }}
            aria-label={`Color ${index + 1}: ${color}`}
          />
          {isHovered && isDeletable && (
            <div className={Styles.deleteButton}>
              <IconButton
                size="xs"
                icon={Trash2}
                aria-label="Delete color"
                onPress={onDeleteClick(index)}
                variant="secondary"
              />
            </div>
          )}
        </div>
        <ResponsiveDesign.Desktop>{color}</ResponsiveDesign.Desktop>
      </div>
    </ColorPicker>
  )
}
